var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3003 5.83194L18.4232 5.50044C17.7957 3.42336 16.4109 1.66025 14.5238 0.535889L13.9189 1.52818C15.5557 2.50333 16.7566 4.03179 17.3003 5.83194Z",
    fill: "#0083EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08043 1.52814L5.47555 0.535889C3.5884 1.66025 2.20359 3.42336 1.57617 5.50044L2.69902 5.83194C3.24281 4.03179 4.44367 2.50333 6.08043 1.52814Z",
    fill: "#0083EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55469 7.98219V14.1915C3.55469 14.565 3.40754 14.9162 3.14039 15.1803C2.65187 15.6633 2.38281 16.3054 2.38281 16.9884V17.907H7.12926C7.40145 19.2275 8.58516 20.2241 10 20.2241C11.4148 20.2241 12.5985 19.2275 12.8707 17.907H17.6172V16.9884C17.6172 16.3054 17.3481 15.6633 16.8596 15.1803C16.5924 14.9162 16.4453 14.565 16.4453 14.1915V7.98219C16.4453 4.66397 13.8663 1.9305 10.5859 1.63681V0.45166H9.41406V1.63681C6.13371 1.93046 3.55469 4.66393 3.55469 7.98219ZM10 19.0656C9.23613 19.0656 8.58484 18.5813 8.34297 17.9067H11.657C11.4152 18.5813 10.7639 19.0656 10 19.0656ZM15.2734 7.98219V14.1915C15.2734 14.8745 15.5425 15.5166 16.031 15.9996C16.2401 16.2063 16.3756 16.4662 16.4247 16.7485H3.57531C3.62437 16.4662 3.75996 16.2062 3.96902 15.9996C4.4575 15.5166 4.72656 14.8745 4.72656 14.1915V7.98219C4.72656 5.1075 7.09223 2.76875 10 2.76875C12.9078 2.76875 15.2734 5.1075 15.2734 7.98219Z",
    fill: "#0083EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.7725,
    fill: "white",
    transform: "translate(0 0.45166)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.3d3995f2ced00bf687399fe8be788553.svg";
export { ForwardRef as ReactComponent };